export const ColorList = {
    violet: '#CC99C9',
    blue: '#9EC1CF',
    green: '#9EE09E',
    yellow: '#FDFD97',
    orange: '#FEB144',
    red: '#FF6663',
}